export const generateKey = async (
  salt: string,
  passPhrase: string,
  keySize: number,
  iterationCount: number,
) => {
  const CryptoJS = (await import('crypto-js')).default;
  const key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
    keySize: keySize / 32,
    iterations: iterationCount,
  });
  return key;
};
